import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Modal, NewButton} from 'components/ui';
import React from 'react';
import './ModalWindow.scss';

export interface ModalWindowProps {
  show: boolean;
  onHide?: () => void;
  loading?: boolean;
  message?: string;
  itensMessage?: any;
  closeButton?: () => void;
}

const ModalWindow: React.FC<ModalWindowProps> = ({
  show = false,
  onHide = () => {},
  loading,
  message = '',
  itensMessage,
  closeButton = () => {},
}) => (
  <Modal
    isOpen={show}
    onClose={onHide}
    clickOutsideToClose={false}
    buttonClose={false}
    minWidth={500}
    maxWidth={500}
    vw={90}
  >
    <div className="ModalWindow">
      {loading && (
        <div>
          <span className="ModalWindow__Spinner">
            <FontAwesomeIcon icon="circle-notch" spin />
          </span>

          <p>Carregando informações...</p>
        </div>
      )}
      {message && <h4>{loading ? 'Carregando...' : message}</h4>}
      {itensMessage && (
        <ul>
          {itensMessage.map((item: any, index: number) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={index} className="danger-text text-left">
              {item}
            </li>
          ))}
        </ul>
      )}
      {closeButton && (
        <div className="ModalWindow__Button">
          <NewButton onClick={closeButton}>Fechar</NewButton>
        </div>
      )}
    </div>
  </Modal>
);

export default ModalWindow;
